import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useLoginStore } from '@/stores/loginStore'

// Importa axios para requisições HTTP
import axios from 'axios';

// Store para gerenciar estado de autenticação
export const useAuthStore = defineStore('autorizacaoLogin', () => {

    // Acessa o roteador para poder chamar formulário de login
    const router = useRouter()

    // Estado reativo para indicar se o usuário está logado
    const estaLogado = ref(localStorage.getItem('autenticado') === 'true')
    
    // Função para sinalizar que está logado
    function logar() {    
        estaLogado.value = true
        localStorage.setItem('autenticado', 'true')
    }

    // Função para fechar a sessão e chamar o formulário de login
    async function deslogar() {
      
        const API_BASE_URL = import.meta.env.VITE_API_URL;
    
        // Acessa a store de login
        const loginStore = useLoginStore()

        // Se existir idColaborador, exclui o mesmo da tabela de
        if (loginStore.idColaborador){

            try{
                // Exclui usuário da tabela de acessos
                const resposta = await axios.post(`${API_BASE_URL}/operacao/deslogar`,
                    { 
                        idColaborador: loginStore.idColaborador
                    }
                );
            } catch (error) {
                console.error('Erro ao deslogar:', error);
            }
        }
        
        // Limpa dados do usuário na store de login
        loginStore.idColaborador = ''
        loginStore.idEmpresa = ''
        loginStore.nomeFantasia = ''
        loginStore.nomeColaborador = ''
        loginStore.loginColaborador = ''
        loginStore.emailColaborador = ''
        loginStore.empresaManutencao = 0    
        loginStore.token = ''

        // Atualiza localStorage
        localStorage.setItem('autenticado', 'false')

        // Muda estado para deslogado
        estaLogado.value = false
        
        // Carrega formulário de login
        router.push({ name: 'Login' })
    }
    
    return { 
        estaLogado,
        logar, 
        deslogar 
    }
})